// checkImgSrc.js

/**
 * Utility function to check if a given image source (src) is valid.
 * @param {string} src - The image source URL to validate.
 * @returns {Promise<boolean>} - Resolves to true if the image is valid, false otherwise.
 */
export const checkImgSrc = async (src) => {
    
    if (typeof src !== 'string' || !src.trim()) {
        return false;
    }
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
    });
};

// Example usage:
// checkImgSrc('https://example.com/image.jpg').then(isValid => console.log(isValid));
